export const environment = {
  production: true,
  apiUrl: 'https://api.triider.com/api',
  boUrl: 'https://bo-leg.triider.com/'
};
